<template>
  <a @click.prevent="handleClick" href="#" class="link" type="button">
    <i :class="alreadyAdded ? 'pi pi-heart-fill' : 'pi pi-heart'"></i>
    <slot></slot>
  </a>
</template>

<script setup lang="ts">
import { useWishlistStore } from "@/stores/wishlist";
import { debounce } from "@/utils/bouncer";
import { computed } from "vue";

const props = defineProps<{
  product: number;
}>();
const wishlist = useWishlistStore();

const alreadyAdded = computed(() => {
  return wishlist.items[props.product];
});

async function handleClick() {
  if (await debounce("wishlist-add", 200)) {
    if (wishlist.items[props.product]) {
      delete wishlist.items[props.product];
    } else {
      wishlist.items[props.product] = 1;
    }
    wishlist.save();
  }
}
</script>

<style scoped>
a {
  padding: 4px;
  font-size: 14px;
}
</style>
